import gate from '@/api/axios';

export const getList = () => gate.get('/partner');
export const getById = (id) => gate.get(`/partner/${id}`);
export const create = (payload) => gate.post('/partner', payload);
export const updateById = (id, payload) => gate.put(`/partner/${id}`, payload);
export const uploadLogoById = (id, payload) => gate.post(`/partner/${id}/logo`, payload);
export const exportOrdersById = (id) => gate.get(`/partner/${id}/ordersExport`, {
  responseType: 'arraybuffer',
});

export default {};
